import React__default from 'react';
import styles from '../../components/cells/statuscard/statuscard.module.scss.js';
import classNames from './../../external_lib/classnames/index.js';
import HorizonText, { TextVariant } from '../../base/HorizonText/index.js';
import img from '../../assets/icons/status-checked.svg.js';
import img$2 from '../../assets/icons/status-unchecked.svg.js';
import img$1 from '../../assets/icons/status-pending.svg.js';
import img$3 from '../../assets/icons/right-arrow-greyed.svg.js';
var StatusCardState;
(function (StatusCardState) {
  StatusCardState["Checked"] = "checked";
  StatusCardState["Pending"] = "pending";
  StatusCardState["UnChecked"] = "unchecked";
})(StatusCardState || (StatusCardState = {}));
function StatusCard(_a) {
  var _b = _a.className,
    className = _b === void 0 ? '' : _b,
    _c = _a.state,
    state = _c === void 0 ? StatusCardState.UnChecked : _c,
    title = _a.title,
    _d = _a.subTitle,
    subTitle = _d === void 0 ? '' : _d,
    infoComponent = _a.infoComponent,
    _e = _a.onCtaClick,
    onCtaClick = _e === void 0 ? function () {} : _e;
  return React__default.createElement("div", {
    className: classNames(styles.StatusCard, className),
    onClick: onCtaClick
  }, React__default.createElement("div", {
    className: styles.StatusCardLeft
  }, React__default.createElement("img", {
    className: styles.StatusCardStateIcon,
    src: state === StatusCardState.Checked ? img : state === StatusCardState.Pending ? img$1 : img$2,
    alt: "Status Icon"
  })), React__default.createElement("div", {
    className: styles.StatusCardCenter
  }, React__default.createElement(HorizonText, {
    className: styles.StatusCardTitle,
    variant: TextVariant.HEADING4
  }, title), React__default.createElement(HorizonText, {
    className: styles.StatusCardSubTitle,
    variant: TextVariant.BODY1
  }, subTitle)), React__default.createElement("div", {
    className: styles.StatusCardRight
  }, infoComponent ? React__default.createElement("div", {
    className: styles.StatusCardInfo
  }, infoComponent) : null, React__default.createElement("img", {
    className: styles.StatusCardRightArrow,
    src: img$3,
    alt: "Right Arrow"
  })));
}
export { StatusCardState, StatusCard as default };
//# sourceMappingURL=index.js.map
